export default __webpack_public_path__ + "static/media/640_portfolio04-es-web.1b8bb1af.png";